<template>
  <div class="media p-3 bg-secondary text-white">
    <div class="mr-3 spinner-grow align-self-center" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="media-body">
      <h5 class="mt-0">NO TYPE OF INSURANCE SELECTED !</h5>
      <div>You did not choose a type of insurance you would like to apply for</div>
      <div>Please select one !</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultContent'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/forms/DefaultContent.vue